import { SimpleChanges } from '@angular/core'
import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { interval, Subscription } from 'rxjs'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'

@Component({
  standalone: false,

  selector: 'vs-idle-timeout-dialog',
  templateUrl: './idle-timeout-dialog.html',
  styleUrls: ['./idle-timeout-dialog.scss'],
})
export class IdleSessionTimeoutDialogComponent implements OnInit {
  private subscription: Subscription
  public secondsToDday = 60

  constructor(private launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.subscription = interval(1000).subscribe((x) => {
      this.secondsToDday = this.secondsToDday - 1
      if (this.secondsToDday == 0) {
        this.subscription.unsubscribe()
        this.closeModal()
      }
    })
    this.launchDialogService.data$.subscribe((data) => {
      this.secondsToDday = data.timeout
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.IDLE_TIMEOUT,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
